import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import AddToFaveIcon from '@wix/da-ds/pkg/Icons/24x24/AddedToFav';
import ErrorIcon from '@wix/da-ds/pkg/Icons/CloseBold';
import Notification from '../../../Notifications/Notification';
import SystemNotification from '../../../SystemNotification';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../../Notifications';
import s from './GroupAddedNotification.scss';
export const GroupAddedNotification = ({ id , queueName , success , error , deviation , needsVote , actionbarType , group: { username  }  })=>{
    const { t  } = useTranslation();
    const group = username || t('common.group');
    const messageType = needsVote ? 'suggested' : 'added';
    const errorMessage = error || t(`addToGroup.notification.fail`);
    const { pushPopover: pushAddToGroupPopover  } = usePopover(actionbarType === 'primary' ? PopoverType.ADD_TO_GROUP_PRIMARY : PopoverType.ADD_TO_GROUP_SECONDARY);
    const { removeNotification  } = useCustomNotifications([
        NotificationType.AddToGroup
    ]);
    const onAddToAnotherGroup = ()=>{
        pushAddToGroupPopover();
        removeNotification(id);
    };
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        cardProps: _object_spread_props(_object_spread({
            iconComponent: success ? AddToFaveIcon : ErrorIcon,
            backgroundDeviation: deviation
        }, error && {
            multiLine: true,
            limitTextWidth: false
        }), {
            actions: [
                {
                    label: t('addToGroup.notification.addToAnotherGroup'),
                    onClick: onAddToAnotherGroup,
                    biData: BiData({
                        evid: 340,
                        deviationid: deviation.deviationId,
                        sectionname: success ? 'add_to_another_group' : 'add_to_group_error'
                    })
                }
            ]
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, success ? t(`addToGroup.notification.${messageType}`, {
        postProcess: 'reactPostprocessor',
        group: /*#__PURE__*/ React.createElement("a", {
            href: username && Url.userLink(username)
        }, group)
    }) : /*#__PURE__*/ React.createElement("span", null, errorMessage)));
};
GroupAddedNotification.displayName = 'GroupAddedNotification';
export default GroupAddedNotification;
